import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { FormBuilder, FormGroup } from '@angular/forms';

export interface RepresentativeDeleteDialogResult {
  deleteContact?: boolean;
}

@Component({
    selector: 'app-representative-delete-dialog',
    templateUrl: './representative-delete-dialog.component.html',
    styleUrls: ['./representative-delete-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RepresentativeDeleteDialogComponent implements OnInit {
  constructor(
    private _actionService: ActionWindowService,
    private _controlModelFactory: FormControlExFactory,
    private _fb: FormBuilder
  ) {}

  private _shouldDeleteContact: boolean = false;
  form: FormGroup;
  languages: { name: string; value: string }[];

  cancel() {
    this._actionService.close();
  }

  ngOnInit() {
    this.form = this._fb.group({
      shouldDeleteContact: this._controlModelFactory.create('Should delete contact', this._shouldDeleteContact),
    });
  }

  onSubmit() {
    if (this.form.invalid) return;

    this._actionService.complete(this.form.value);
  }
}
